// src/components/WhySection.jsx
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faMagnifyingGlassChart,
  faGlobe,
  faRocket,
  faChartLine,
} from '@fortawesome/free-solid-svg-icons';

import './WhySection.css';

export default function WhySection() {
  const benefits = [
    {
      icon: faMagnifyingGlassChart,
      title: 'Altijd online vindbaar',
      desc: 'Wij zorgen dat je bedrijf bovenaan komt te staan in Google en andere zoekmachines.',
    },
    {
      icon: faGlobe,
      title: 'Professionele uitstraling',
      desc: 'Websites die overtuigen én converteren. Modern, snel en afgestemd op jouw doelgroep.',
    },
    {
      icon: faChartLine,
      title: 'Slimme SEA + SEO-combo',
      desc: 'Combineer gratis zoekverkeer met slimme advertenties voor maximaal bereik.',
    },
    {
      icon: faRocket,
      title: 'Groeigericht systeem',
      desc: 'Elke dienst is erop gericht om klanten uit je online kanalen te halen – meetbaar en schaalbaar.',
    },
  ];

  return (
    <section className="why-section py-5">
      <div className="container">
        <header className="text-center mb-5">
          <h2 className="why-title">Waarom OnlineGrowthClub.nl?</h2>
          <p className="why-subtitle">Alles wat je nodig hebt om online klanten te winnen</p>
        </header>

        <ul className="why-cards">
          {benefits.map(({ icon, title, desc }) => (
            <li key={title} className="why-card">
              <span className="why-icon-wrap">
                <FontAwesomeIcon icon={icon} />
              </span>
              <h3 className="why-card-title">{title}</h3>
              <p className="why-card-desc">{desc}</p>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}